import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

// "Install OCTON Gym" on phones: Android/Chrome uses the browser's install prompt,
// iPhone/iPad Safari gets the two-tap Add to Home Screen instructions.
const KEY = "octon_install_dismissed";

export function InstallApp() {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const [hide, setHide] = useState(true);
  useEffect(() => {
    let dismissed = false;
    try { dismissed = Date.now() - Number(localStorage.getItem(KEY) || 0) < 14 * 86400000; } catch (_) {}
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone;
    if (standalone || dismissed) return undefined;
    const ua = window.navigator.userAgent || "";
    const isIos = /iphone|ipad|ipod/i.test(ua) || (ua.includes("Macintosh") && "ontouchend" in document);
    if (isIos) { setIos(true); setHide(false); }
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); setHide(false); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const onInstalled = () => setHide(true);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  const close = () => { setHide(true); try { localStorage.setItem(KEY, String(Date.now())); } catch (_) {} };
  if (hide) return null;
  return (
    <div className="md:hidden fixed left-3 right-3 z-40 rounded-2xl border border-acid/40 bg-[#0F1115]/95 backdrop-blur p-3 shadow-2xl flex items-center gap-3"
      style={{ bottom: "calc(4.5rem + env(safe-area-inset-bottom))" }} data-testid="install-app">
      <img src="/apple-touch-icon.png" alt="" className="w-11 h-11 rounded-xl" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Install OCTON Gym</p>
        {ios && !evt ? (
          <p className="text-xs text-[#8A91A6]">Tap <Share className="inline w-3.5 h-3.5 -mt-0.5" /> Share, then <b>Add to Home Screen</b>.</p>
        ) : (
          <p className="text-xs text-[#8A91A6]">Full screen, on your home screen, one tap away.</p>
        )}
      </div>
      {evt && (
        <button onClick={async () => { evt.prompt(); await evt.userChoice.catch(() => {}); setEvt(null); setHide(true); }}
          className="h-9 px-4 rounded-full bg-acid text-black text-sm font-medium inline-flex items-center gap-1.5"><Download className="w-4 h-4" /> Install</button>
      )}
      <button onClick={close} className="p-1 text-[#8A91A6]" aria-label="Dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
